import React, {useEffect, useState} from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import UserDataForm from '../../global-elements/userDataForm'
import ValidatorService from "../../../../services/validator";
import Banner from "../../../body/banners/banner";
import '../../../../assets/terms/dm-terms.css';
import marketing from "../../../../services/marketing"
import ErrorModal from "../../../body/forms/components/ErrorModal";
import Recaptcha from "../../../body/forms/components/recaptcha/Recaptcha";
import InvalidStateModal from "../../global-elements/invalidStateModal";
import PixelsService from '../../../../services/pixels';
import '../../../../assets/standalone/standalone.css';
import AudioEyeSupport from "../../../../services/audioEyeSupport";
import SubmitApplicationService from "../../../../services/submitApplication";
import AdobeScript from "../../../../services/adobeScript";
import FeaturesService from "../../../../services/features";
import AxiosWrapper from "../../../../services/axios";
import Wildcard from "../../../../services/wildcard";
import { InactiveDetection } from "../../../../services/inactiveDetection";
import SocialProofPopup from "../../global-elements/satisfactionPopup";
import ExitOverlayModal from "../../global-elements/exitOverlayModal";
import PrequalAuthorizationConsent from "../../global-elements/PrequalAuthorizationConsent";
import { PRODUCT } from "../../../../models/websiteTypesConstants";
import { ExperianBanner } from "../../../body/banners/experianBanner";

function Landing() {

    const ada = new AudioEyeSupport();
    const Pixels = new PixelsService();
    const Setting = useStoreState((state) => state.siteSettingsModel);
    const MainPath = useStoreState((state) => state.siteSettingsModel.MainPath);
    const setGrandBanckDeclined = useStoreActions((actions) => actions.siteSettingsModel.setGrandBanckDeclined);
    const info = useStoreState((state) => state.applicantModel.applicant);
    const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
    const setApplicationResult = useStoreActions(actions => actions.applicationResultModel.setApplicationResult);
    const resultStep = useStoreActions(actions => actions.setDisplayResult);
    const history = useHistory();
    const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
    const [errorShow, setErrorShow] = useState(false);
    const closeError = () => setErrorShow(false);
    const InvalidState = useStoreState((state) => state.invalidState);
    const setInvalidState = useStoreActions((actions) => actions.setInvalidState);
    const [errorMessage, setErrorMessage] = useState(false);
    const validatorService = new ValidatorService();
    const methods = useForm({mode: 'onSubmit'});
    const [isLoading, setLoading] = useState(false);
    const useRecaptcha = useStoreState((state) => state.siteSettingsModel.useRecaptcha);
    let brandSettings = useStoreState((state) => state.siteSettingsModel.brandSettings);
    const setdisplayTerms = useStoreActions((actions) => actions.setDisplayPrequalTerms);
    const [recaptchaDisabled, setRecaptchaDisabled] = useState(true);
    const utms = new marketing();
    const pendingInfo = ["FROZEN", "FROZENPREQUAL", "PENDFEE", "PENDFUNDING", "PENDINFO", "PENDINTERNAL"];
    const setInitPixels = useStoreActions(actions => actions.setInitPixels);
    const initPixels = useStoreState(state => state.initPixels);
    const PixelService = new PixelsService();
    const bannerbgImageSurgeReflexDesktop = Setting.brandSettings.ProductName === PRODUCT.Surge ? 
    "https://imagestest.continentalfinance.net/applicationweb/Surge/Surge-Stand-Alone-500-Card-Art-Lower.png"
    : (Setting.brandSettings.ProductName === PRODUCT.Reflex ? "https://imagestest.continentalfinance.net/applicationweb/Reflex/feature_section.png"
        : brandSettings.CardImage);
    const submitApplicationService = SubmitApplicationService();
    const adobe = new AdobeScript();
    const [isHalfScrolled, setIsHalfScrolled] = useState(false);
    const features = new FeaturesService();
    const setDeclineOffers = useStoreActions(actions => actions.siteSettingsModel.setDeclineOffers);
    const domain = useStoreState(state => state.siteSettingsModel.domain);
    const client = new AxiosWrapper()
    const setMfaSms = useStoreActions(actions => actions.setMfaSms);
    const wildcard = new Wildcard();
    const [tcHasErrors, setTcHasErrors] = useState(false);
    const isRecaptchaBlocking = useRecaptcha && Setting.productSettings.CaptchaKey !== null && recaptchaDisabled;
    const isDisabled = isLoading || tcHasErrors || isRecaptchaBlocking;

    InactiveDetection.setInactiveTitle("Don’t miss this great offer!");

    useEffect(() => {
        if(!initPixels) {
            utms.mapper();
            ada.setup();
            utms.trackEvent(19, "STANDALONE", "", Setting.productSettings.ProductId, "Flow");
            PixelService.initialize().pageView("/landing").event("google", "STANDALONE", "Landing Page");
            getRoutingSettings({ Url: Setting.domain, Route: window.location.pathname});
            setInfo({ index : 'ProductCode', value : Setting.mainSettings.ProductCode })
            setInfo({ index : 'Url', value : domain });
            adobe.setup();
            setTimeout(() =>  adobe.startEvent('page_view'), 5000);
            setInitPixels(true)
        }
        
    }, []);

    useEffect(() => {
        const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const fullHeight = document.body.scrollHeight;
        const scrolledToBottom = scrollPosition + windowHeight;

        if (scrolledToBottom >= fullHeight / 2 && isHalfScrolled === false){
            setIsHalfScrolled(true)
        }
    };
    
    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
    }, [isHalfScrolled]);

    useEffect(() => {
    if (isHalfScrolled) {
        scrollEvent();
    }
    }, [isHalfScrolled]);

    const scrollEvent = () => {
        adobe.event('scroll')
    };

    const submit = async (data) => {
        setLoading(true);
        await submitApplication(data);
        setLoading(false);
    }

    async function submitApplication(data){
        if(validatorService.preValidations(data, methods, info)) return;
        if(!await validatorService.EmailValidate(info.Email, methods)) return;
        if(!await validatorService.addressValidateV2(info, methods, setInvalidState) === true) return;

        let response = await submitApplicationService.submitApplication(info, true);
        let payload = response.Payload;

        if (response.Success){
            if (payload) {
                if (payload.IsGrandbank === true) { setGrandBanckDeclined(true); }
        
                if (payload.result != null) {
                if(payload.result){     utms.updateSessionReport("appResult",   payload.result.toUpperCase() ); }
                if(payload.ref_number){ utms.updateSessionReport("applicantId", payload.ref_number); }
                window.cl = payload.credit_limit ?? 0;
                //Decline Offers for BMG box
                setDeclineOffers(payload.DeclineOffers || null);
            
                setInfo({ index: "step", value: 3 });
                setApplicationResult(payload);
                resultStep(true);
                window.scrollTo(0, 0);

                if(payload.result.toUpperCase() === "APPROVED") {
                    setdisplayTerms(true);
                
                    history.push(MainPath + "terms" + window.location.search);
                    return;
                }

                //New Bank Account call for Dynamic call
                if(features.isLinkBankAccountFeatureEnabled()  && payload.result.toUpperCase() === 'PENDUSER') {
                    history.push(MainPath + "link-account" + window.location.search);
                    return;
                }

                if (pendingInfo.includes(payload.result.toUpperCase())) {
                    history.push(MainPath + "pendinfo" + window.location.search);
                    return;
                }
                history.push(MainPath + "decision" + window.location.search);
                return;
                }
            } else {
                setErrorMessage("An unknown error has occured. Please try again.");
                setErrorShow(true);
                setLoading(false);
            }
        } else {
            payload.decline_message='We are currently processing your application, and you will receive a decision within 30 days.'
            setDeclineOffers(payload.DeclineOffers || null);
            setInfo({ index: "step", value: 3 });
            setApplicationResult(payload);
            resultStep(true);
            window.scrollTo(0, 0);
            history.push(MainPath +"decision" + window.location.search);
            return;
        }
    };

    return (
        <>
            <ExperianBanner />
            <Banner />
            <ErrorModal size="sm" show={errorShow} message={errorMessage} closeError={closeError}/>
            <ExitOverlayModal disabled={isLoading} />
            <InvalidStateModal visible={InvalidState} />
            
            <div className="container mt-3 mb-5">
                <SocialProofPopup></SocialProofPopup>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(submit)}>
                        <div  className="dm-form">
                            <UserDataForm />
                            <PrequalAuthorizationConsent disabledFields={isDisabled} />
                        </div>
                        <div className="row">
                            <div className="captcha-container">
                                {Setting.productSettings.CaptchaKey !== null && (
                                    <div className="form-group displayFlexCenter">
                                        <Recaptcha setRecaptchaDisabled={setRecaptchaDisabled} ProductName={brandSettings.ProductName}/>
                                    </div>
                                )}
                            </div>
                        </div>
                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <button 
                                        onClick={() => {
                                            adobe.event('see_my_card_offers', Setting.CardColors.find(value => value.Code === info.cardColorCode));
                                            Pixels.event("google", "PREQUAL", "Submit Application");
                                        }}
                                        disabled={isLoading || ((Setting.productSettings.CaptchaKey !== null) && recaptchaDisabled)}
                                        id="submit-app"
                                        style={{backgroundColor : Setting.brandSettings.Tertiary, minWidth: '200px', width : "22%", color: "white"}}
                                        className="btn text-small mt-3 rounded-pill"
                                        type="submit">
                                        {isLoading ? 'Submitting...' : 'See My Offer'}
                                    </button>
                                </div>
                            </div>
                    </form>
                </FormProvider>
            </div>
        </>
        
    );
}

export default Landing;
